import { RootState } from '../../../config/redux/store';
import { IEnterpriseSlice } from './type';

export const selectEnterpriseState = (state: RootState): IEnterpriseSlice =>
	state.enterprise;